import { useState } from "react";
import { LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SupportDialog } from "@/components/SupportDialog";

type ButtonProps = React.ComponentProps<typeof Button>;

export function SupportTrigger({
  label = "Support",
  withIcon = true,
  ...buttonProps
}: ButtonProps & { label?: string; withIcon?: boolean }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button type="button" onClick={() => setOpen(true)} {...buttonProps}>
        {withIcon && <LifeBuoy className="mr-1.5 size-4" />}
        {label}
      </Button>
      <SupportDialog open={open} onOpenChange={setOpen} />
    </>
  );
}

/** Für Menüs/Links: rendert nur den Trigger als Text, das Dialog-Handling bleibt hier. */
export function SupportLinkTrigger({
  className,
  label = "Support",
  onOpen,
}: {
  className?: string;
  label?: string;
  onOpen?: () => void;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={() => {
          setOpen(true);
          onOpen?.();
        }}
      >
        {label}
      </button>
      <SupportDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
